import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';

// Actions
import { paisesActions } from '../../../../application/actions/paises';

// import { loadersActions } from '../../../../application/actions/ui_loaders';
// import { logReqError } from '../../../ui/utils/functions';

import api from '../../../api';

const apiPaises = api(process.env.REACT_APP_URL);

export function* fetchPaisesFuncion() {
    try {
        const token = "123456789";

        const optionalsHeaders = {
            'Authorization': `Bearer ${token}`
        }

        const { data } = yield call(apiPaises.get, 'parametro/pais', '' , optionalsHeaders);

        if (data) {
            yield put(paisesActions.validarPaises({ responsePaises: data.data.paises }));
        } else {
            yield put(paisesActions.validarPaisesError());

        }

    } catch {

        yield all([
            put(paisesActions.validarError())
        ]);
    }
}

export function* watchFetchPaises() {
    yield takeLatest(paisesActions.paisesServicio.type, fetchPaisesFuncion);
}

export default function* rootSaga() {
    yield spawn(watchFetchPaises);
}
